// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.components-wrap {\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n}\n.video-size-wrap {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n@keyframes fseqAnimation {\n0% {\n    background-position: 0 0;\n}\n100% {\n    background-position: 0 100%;\n}\n}\n.steps_anim {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 50%;\n  left: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
